import { Button, styled } from '@mui/material';

/**
 * Botón personalizado de continuar proceso
 */
export const BottonContinuarProceso = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  padding: '14px 32px 13px 32px',
  border: '1px solid',
  height: '45px',
  borderRadius: '26px',
  lineHeight: 1.5,
  fontWeight: 600,
  backgroundColor: 'var(--primario-morado)',
  borderColor: 'var(--primario-morado)',
  fontFamily: ['Neutrif Studio'].join(','),
  '&:hover': {
    backgroundColor: 'var(--morado-l36)',
    borderColor: 'var(--morado-l36)',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: 'var(--primario-morado)',
    borderColor: 'var(--primario-morado)',
  },
});

/**
 * Botón personalizado de cancelar proceso
 */
export const BottonCancelarProceso = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  padding: '14px 32px 13px 32px',
  border: '2px solid',
  height: '45px',
  borderRadius: '26px',
  lineHeight: 1.5,
  fontWeight: 600,
  backgroundColor: 'rgba(30, 30, 30, 1)',
  borderColor: 'var(--blanco)',
  fontFamily: ['Neutrif Studio'].join(','),
  '&:hover': {
    backgroundColor: '#343333',
    borderColor: 'var(--blanco)',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: 'rgba(30, 30, 30, 1)',
    borderColor: 'var(--blanco)',
  },
});
